var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section__head"},[_c('h2',[_vm._v("\n\t\t"+_vm._s(_vm.title)+"\n\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t"+_vm._s(_vm.description)+" "),_c('br'),_vm._v("\n\t\t"+_vm._s(_vm.description2)+"\n\t")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e67a96e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionHead.vue
// module id = 424
// module chunks = 0